

// Deux pastilles rondes (desktop, mobile) + une phrase qui dit où le test tourne.
// `desktop` / `mobile` : true si le variant a été configuré sur ce device.

function DesktopIcon({ slashed }) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<rect x="3" y="4" width="18" height="12" rx="2" />
			<path d="M8 20h8M12 16v4" />
			{slashed && <path d="M3.5 3.5l17 17" stroke="#5B616B" />}
		</svg>
	);
}

function MobileIcon({ slashed }) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<rect x="7" y="2.5" width="10" height="19" rx="2.5" />
			<path d="M11 18.5h2" />
			{slashed && <path d="M3.5 3.5l17 17" stroke="#5B616B" />}
		</svg>
	);
}

function getCopy(desktop, mobile) {
	if (desktop && mobile) return { title: 'This test runs on desktop and mobile.', hint: 'Both devices are set up.' };
	if (desktop) return { title: 'This test runs on desktop only.', hint: "Mobile isn't set up yet." };
	if (mobile) return { title: 'This test runs on mobile only.', hint: "Desktop isn't set up yet." };
	return { title: "This test isn't set up on any device yet.", hint: 'Edit your variant to choose where it runs.' };
}

export default function DeviceIndicator({ desktop = false, mobile = false }) {
	const { title, hint } = getCopy(desktop, mobile);

	return (
		<div className="lt-device">
			<div className="lt-device__badges" aria-hidden="true">
				<span className={`lt-device__badge ${desktop ? 'is-on' : 'is-off'}`}>
					<DesktopIcon slashed={!desktop} />
				</span>
				<span className={`lt-device__badge ${mobile ? 'is-on' : 'is-off'}`}>
					<MobileIcon slashed={!mobile} />
				</span>
			</div>
			<div>
				<div className="lt-device__title">{title}</div>
				<div className="lt-device__hint">{hint}</div>
			</div>
		</div>
	);
}
